<!-- /live's sessions already over today (LiveEvent.vue), collapsed into one row above the
     session live now: a caret and stacked lines (the cards folded away) say "open me"; opened,
     each session is its card as it was before it began, marked Ended (Seán, 2026-11-03: not the
     program's rows). Also the event coming up, collapsed the same way under the one on show
     (LiveEvent.vue, isUpcoming; Seán, 2026-11-03: one event at a time), its label the slot's. -->

<template>
  <div class="earlierToday">
    <button
      type="button"
      class="toggle"
      :aria-expanded="String(isOpen)"
      :aria-controls="listId"
      @click="isOpen = !isOpen">
      <span class="caret" :class="{isOpen}" aria-hidden="true">▸</span>
      <svg class="lines" viewBox="0 0 24 18" aria-hidden="true">
        <rect y="0" width="24" height="3" rx="1.5" />
        <rect y="7.5" width="24" height="3" rx="1.5" />
        <rect y="15" width="24" height="3" rx="1.5" />
      </svg>
      <span class="label"><slot>Earlier today</slot></span>
    </button>
    <div v-if="isOpen" :id="listId" class="cards">
      <EventItem v-for="item in sessions" :key="getSessionKey(item)" :item="item" />
    </div>
  </div>
</template>

<script setup>
import {ref, useId} from "vue";
import EventItem from "@/components/EventItem";
import {getSessionKey} from "@/composables/sessionKey";

defineProps({sessions: {type: Array, default: () => []}});

const isOpen = ref(false);
const listId = useId();
</script>

<style scoped>
.earlierToday {
  border-radius: 12px;
  background-color: var(--background-color-subtle);
}
/* a button that's a row, not a button: global.css's button look reset (CLAUDE.md) */
button.toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 52px;
  padding: 8px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: none;
  background: none;
  color: var(--text-color);
  font: inherit;
  font-size: 1.25rem;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}
button.toggle:hover .lines,
button.toggle:hover .caret {
  opacity: 1;
}
.caret {
  display: inline-block;
  width: 1em;
  opacity: 0.7;
  transition: transform 150ms ease-out;
}
.caret.isOpen {
  transform: rotate(90deg);
}
.lines {
  width: 24px;
  height: 18px;
  fill: currentColor;
  opacity: 0.7;
}
.cards {
  display: flex;
  flex-direction: column;
  gap: var(--live-card-gap, 16px); /* as the cards below (Live.vue) */
  padding: 0 0 15px;
}
@media (prefers-reduced-motion: reduce) {
  .caret {
    transition: none;
  }
}
</style>
